<h1 style="margin: auto; text-align: center">LOGOUT...</h1>
